import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const CHECK_MODAL = `${BASE_URL}/rest/v1.0/users/{username}/modals`;
export const CHECK_MODAL_TYPE = `${CHECK_MODAL}?modalType={modalType}`;
export const CONSENT_URL = `${BASE_URL}/rest/v1.0/user/{username}/consent`;
export const CONSENT_URL_LIST = `${CONSENT_URL}/with-decision`;
